import { PostSource } from './constants';

export const getSourceDisplayText = (source?: PostSource) => {
    if (source === PostSource.INSTAGRAM) {
        return 'Instagram*';
    }

    if (source === PostSource.TELEGRAM) {
        return 'Telegram';
    }

    return 'Яндекс Ритм';
};
